var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/AdvertisingBanner/AdvertisingBanner.jinja"] = require( "front/components/AdvertisingBanner/AdvertisingBanner.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/PerspectiveSubscribe/PerspectiveSubscribe.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/PerspectiveSubscribe/PerspectiveSubscribe.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n";
env.getTemplate("front/components/AdvertisingBanner/AdvertisingBanner.jinja", false, "assets/app/front/components/PerspectiveSubscribe/PerspectiveSubscribe.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
if(Object.prototype.hasOwnProperty.call(t_4, "AdvertisingBanner")) {
var t_7 = t_4.AdvertisingBanner;
} else {
cb(new Error("cannot import 'AdvertisingBanner'")); return;
}
context.setVariable("AdvertisingBanner", t_7);
if(Object.prototype.hasOwnProperty.call(t_4, "ADVERTISING_PERSPECTIVE_2")) {
var t_8 = t_4.ADVERTISING_PERSPECTIVE_2;
} else {
cb(new Error("cannot import 'ADVERTISING_PERSPECTIVE_2'")); return;
}
context.setVariable("ADVERTISING_PERSPECTIVE_2", t_8);
output += "\n\n\n";
var macro_t_9 = runtime.makeMacro(
[], 
["data", "advertising"], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
frame.set("data", Object.prototype.hasOwnProperty.call(kwargs, "data") ? kwargs["data"] : {});frame.set("advertising", Object.prototype.hasOwnProperty.call(kwargs, "advertising") ? kwargs["advertising"] : {});var t_10 = "";t_10 += "\n    <div class=\"PerspectiveSubscribe ";
if(runtime.contextOrFrameLookup(context, frame, "advertising") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_PERSPECTIVE_2")) && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_PERSPECTIVE_2")))) {
t_10 += "PerspectiveSubscribe--hasAdvertising";
;
}
t_10 += "\">\n        <h2 class=\"PerspectiveSubscribe-header\">Subscribe to print Edition</h2>\n\n        <div class=\"PerspectiveSubscribe-inner\">\n            <div class=\"PerspectiveSubscribe-info\">\n                ";
t_10 += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"subscribe_content_rendered")), env.opts.autoescape);
t_10 += "\n            </div>\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"subscribe_document")) {
t_10 += "<a href=\"";
t_10 += runtime.suppressValue((lineno = 14, colno = 53, runtime.callWrap(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"subscribe_document")),"url"), "data[\"subscribe_document\"][\"url\"]", context, [])), env.opts.autoescape);
t_10 += "\" target=\"_blank\" class=\"PerspectiveSubscribe-btnSubscribe\">Subscribe</a>\n            ";
;
}
t_10 += "</div>\n\n        ";
if(runtime.contextOrFrameLookup(context, frame, "advertising") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_PERSPECTIVE_2")) && env.getFilter("length").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_PERSPECTIVE_2")))) {
t_10 += "\n            <div class=\"PerspectiveSubscribe-advertisingBannerWrapper\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                ";
t_10 += runtime.suppressValue((lineno = 20, colno = 34, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AdvertisingBanner"), "AdvertisingBanner", context, [runtime.makeKeywordArgs({"data": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "advertising")),runtime.contextOrFrameLookup(context, frame, "ADVERTISING_PERSPECTIVE_2")),"size": "square","position": "PERSPECTIVE – POSITION 2"})])), env.opts.autoescape);
t_10 += "\n            </div>\n        ";
;
}
t_10 += "\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_10);
});
context.addExport("PerspectiveSubscribe");
context.setVariable("PerspectiveSubscribe", macro_t_9);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/PerspectiveSubscribe/PerspectiveSubscribe.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/PerspectiveSubscribe/PerspectiveSubscribe.jinja
// module id = 512
// module chunks = 0